import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {UploadButton} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/UploadButton/UploadButton';
import {DeleteButton} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/DeleteButton/DeleteButton';
import {
  UPDATE_PRISTINE_UYO,
  UPDATE_DESIGN_OPTIONS,
} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';

export const ActionButtons = ({canvas, id, editorDisabled}) => {
  const dispatch = useDispatch();

  const imageUploadedCallback = useCallback(
    (uploadedUyo) => {
      const previousActiveObj = canvas.getActiveObject();
      canvas.remove(previousActiveObj);
      canvas.discardActiveObject();
      canvas.fire('object:removed');
      canvas.setActiveObject(uploadedUyo);
      canvas.renderAll();
      dispatch({
        type: UPDATE_PRISTINE_UYO,
        payload: {pristineUyo: false, id, objects: canvas.getObjects()},
      });
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {activeCardEditor: 'image'},
      });
    },
    [canvas, dispatch, id]
  );

  return (
    <div className="uyo-control-actions">
      <div className="uyo-control-action-button">
        <UploadButton
          showFullWidth
          btnText="Swap photo"
          id={id}
          index={id}
          callback={imageUploadedCallback}
        />
      </div>
      <div className="uyo-control-action-button">
        <DeleteButton btnText="Delete" disabled={editorDisabled} semibold />
      </div>
    </div>
  );
};
